export enum EBrand {
  Aveda = 'Aveda',
  Mac = 'Mac',
}
